import { useRef } from "react";

function DateCell({
  day,
  dateStr,
  holiday,
  value = 0,
  onChange,
}: {
  day: number;
  dateStr: string;
  holiday: { weekend: number; isHol: boolean };
  value?: number;
  onChange?: (val: number) => void;
}) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    // 숫자만 입력 가능하도록 필터링
    if (/^\d*$/.test(inputValue)) {
      onChange?.(Number(inputValue));
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.currentTarget.blur();
    }
  };

  const displayValue = value > 0 ? String(value) : "";
  const hasValue = displayValue !== "";

  return (
    <div
      onClick={handleClick}
      className={`w_selectCalendar_date font-pretendard font-medium !text-[15px] focus-within-input text-text-sub cursor-pointer w-full h-full
              ${holiday.weekend === 6 ? "!text-text-sat" : holiday.weekend === 0 ? "!text-text-sun" : ""}
              ${holiday.isHol && "!text-text-holiday"}
               ${hasValue && "!bg-[#F0F0F2]"}
              `}
    >
      <div className="calendar-date !p-1 !top-[1px] !left-[1px] relative w-full h-full">
        <div className="flex items-end justify-center w-full h-full">
          <span className="absolute top-[7px] left-[8px]">{day}</span>

          <div className="flex">
            <input
              ref={inputRef}
              type="text"
              value={displayValue}
              onChange={handleChange}
              onFocus={(e) => e.target.select()}
              onKeyDown={handleKeyDown}
              className={`w-[35px] text-center bg-transparent outline-none border-none text-xl! font-medium font-pretendard p-0 ${
                hasValue ? "text-[#0E59C6]" : "text-transparent"
              }`}
              placeholder=""
            />
          </div>
          {hasValue && (
            <span className="font-pretendard font-light text-[16px] !text-text-sub">
              개
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
export default DateCell;
